<template>
  <div class="card same-height">
    <div class="card-image">
      <b-carousel
        :autoplay="false"
        :overlay="gallery"
        with-carousel-list
        :indicator="false"
        @click="switchGallery(true)"
      >
        <b-carousel-item
          v-for="(carousel, i) in productInfo.images"
          :key="i"
        >
          <figure class="image">
            <b-image
              :src="getImgUrl(carousel.image)"
              webp-fallback=".jpg"
              ratio="4by3"
            >
              <b-skeleton
                class="skeleton-placeholder"
                slot="placeholder"
                height="100%"
              />
            </b-image>
          </figure>
        </b-carousel-item>
        <template
          slot="list"
          slot-scope="props"
        >
          <b-carousel-list
            v-model="props.active"
            :data="productInfo.images"
            v-bind="al"
            @switch="props.switch($event, false)"
            as-indicator
          />
        </template>
        <span
          v-if="gallery"
          @click="switchGallery(false)"
          class="modal-close is-large"
        />
        <template
          slot="indicators"
          slot-scope="props"
        >
          <figure
            class="al image"
            :draggable="false"
          >
            <b-image
              :draggable="false"
              :src="getImgUrl(productInfo.images[props.i])"
              webp-fallback=".jpg"
              ratio="4by3"
            />
          </figure>
        </template>
      </b-carousel>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="is-size-3">
          {{ productInfo.name }}
        </div>

        {{ productInfo.description }}
        <br>
        <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    productInfo: {
      type: Object,
      name: 'undefined',
      images: [],
      description: 'undefined'
    }
  },
  data () {
    return {
      gallery: false,
      al: {
        hasGrayscale: true,
        itemsToShow: 4
      }
    }
  },
  methods: {
    getImgUrl (value) {
      return value
    },
    switchGallery (value) {
      this.gallery = value
      if (value) {
        document.documentElement.classList.add('is-clipped')
      } else {
        document.documentElement.classList.remove('is-clipped')
      }
    }
  }
}
</script>

<style>
.same-height {
  height: 100%;
  display:flex;
  flex-direction: column;
}

.same-height:hover {
  background-color:grey;
}

.is-active .al img {
    border: 1px solid #fff;
    filter: grayscale(0%);
}
.al img {
    border: 1px solid transparent;
    filter: grayscale(100%);
}
</style>
